// Use document-level delegation so it survives Dawn re-renders
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.color-swatch');
  if (!swatch) return;
  onSwatchClick(swatch);
});

function onSwatchClick(swatch) {
  var fieldset = swatch.closest('fieldset');
  if (!fieldset) return;

  var value = swatch.dataset.optionValue;

  // Update active ring visually
  fieldset.querySelectorAll('.color-swatch').forEach(function (s) {
    s.classList.remove('active');
    s.setAttribute('aria-pressed', 'false');
    s.removeAttribute('aria-current');
  });
  swatch.classList.add('active');
  swatch.setAttribute('aria-pressed', 'true');
  swatch.setAttribute('aria-current', 'true');

  // Update the label
  var selectedLabel = fieldset.querySelector('[data-selected-value]');
  if (selectedLabel) {
    selectedLabel.textContent = value;
  }

  // Find and trigger the matching hidden radio
  var radios = fieldset.querySelectorAll('.css-swatch__hidden-radios input[type="radio"]');
  radios.forEach(function (radio) {
    if (radio.value === value) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      radio.checked = false;
    }
  });
}
document.addEventListener('click', function(e) {
  var swatch = e.target.closest('.card-swatches .color-swatch');
  if (!swatch) return;
  e.preventDefault();
  e.stopPropagation();
  var url = swatch.dataset.url;
  if (url) window.location.href = url;
});

document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href*="size-guide"], a[href*="size_guide"]');
  if (!link) return;
  e.preventDefault();
  var thumbnails = document.querySelectorAll('.product__media-list .thumbnail-list__item, .thumbnail-list button');
  if (thumbnails.length === 0) return;
  var lastThumb = thumbnails[thumbnails.length - 1];
  lastThumb.click();
  lastThumb.scrollIntoView({ behavior: 'smooth' });
});